import React, { Component } from "react";
import { CustomInputComponent } from "../../../../shared";
import { usStates } from "../../../../../common/_us_states";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Button } from "semantic-ui-react";

const prefilledCardData = {
  address: "10 Bonn Ln",
  cardNumber: "4111111111111111",
  city: "Fayetteville",
  code: "111",
  expMonth: "01",
  expYear: "22",
  state: "GA",
  zip: "30215",
};

class PaymentForm extends Component {
  render() {
    let cardData = {
      address: "",
      cardNumber: "",
      city: "",
      code: "",
      expMonth: "",
      expYear: "",
      state: "",
      zip: "",
    };

    if (process.env.ENV === "dev") {
      cardData = { ...prefilledCardData };
    }

    const fields = [
      {
        name: "fullName",
        initialValue: this.props.fullName,
        label: "Name On Card",
        required: true,
        schema: () => Yup.string().min(2, "Too Short!").required("Required"),
      },
      {
        name: "cardNumber",
        initialValue: cardData.cardNumber,
        label: "Card Number",
        required: true,
        schema: () =>
          Yup.string()
            .matches(/^[0-9]{15,16}$/, "Must be 15 or 16 digits")
            .required("Required"),
      },
      {
        name: "expMonth",
        initialValue: cardData.expMonth,
        label: "Exp Month (MM)",
        required: true,
        schema: () =>
          Yup.string()
            .matches(/^[0-9]{2}$/, "Must be exactly 2 digits")
            .required("Required"),
      },
      {
        name: "expYear",
        initialValue: cardData.expYear,
        label: "Exp Year (YY)",
        required: true,
        schema: () =>
          Yup.string()
            .matches(/^[0-9]{2}$/, "Must be exactly 2 digits")
            .required("Required"),
      },
      {
        name: "code",
        initialValue: cardData.code,
        label: "CVV Number",
        required: true,
        schema: () =>
          Yup.string()
            .matches(/^[0-9]*$/, "Digits only")
            .required("Required"),
      },
      {
        name: "address",
        initialValue: cardData.address,
        label: "Billing Address",
        required: true,
        schema: () => Yup.string().required("Required"),
      },
      {
        name: "city",
        initialValue: cardData.city,
        label: "Billing City",
        required: true,
        schema: () => Yup.string().required("Required"),
      },
      {
        name: "state",
        initialValue: cardData.state,
        label: "Billing State",
        select: true,
        search: true,
        options: usStates,
        required: true,
        schema: () => Yup.string().required("Required"),
      },
      {
        name: "zip",
        initialValue: cardData.zip,
        label: "Billing Zip",
        required: true,
        schema: () =>
          Yup.string()
            .matches(/^[0-9]{5}$/, "Must be exactly 5 digits")
            .required("Required"),
      },
      {
        name: "email",
        initialValue: this.props.email,
        label: "Email",
        required: true,
        schema: () =>
          Yup.string().email("Invalid Email Address").required("Required"),
      },
    ];

    let initialValues = {};

    fields.forEach((f) => {
      initialValues[f.name] = f.initialValue;
    });

    const schemas = fields.reduce(
      (acc, cur) => ({
        ...acc,
        [cur.name]: cur.schema(),
      }),
      {}
    );

    const schema = Yup.object().shape(schemas);

    const { loading } = this.props;

    return (
      <div data-private>
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values) => this.props.onSubmit(values)}
        >
          {({ errors, touched }) => (
            <Form className={`ui form large ${loading ? "loading" : ""}`}>
              {fields.map((f, i) => (
                <Field
                  component={CustomInputComponent}
                  key={i}
                  label={f.label}
                  name={f.name}
                  options={f.options}
                  required={f.required}
                  select={f.select}
                  search={f.search}
                />
              ))}
              <Button
                color="blue"
                type="submit"
                fluid
                content="Pay"
                size="huge"
                style={{ marginTop: "10px" }}
              />
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default PaymentForm;
